<template>
  <basic-container>
    <div class="bankmanageDetail">
      <div class="bankdetail_title">
        <div class="banktail_">
          <Details
            :detaildeta="detaildeta"
            :data="data"
            @updatastate="updatastate"
            @quanxian="quanxian"
            @passcheck="passcheck"
            @changes="changes"
            @edit="edit"
          />
          <Detaillist
            :detaillist="detaillist"
            :data="data"
            @warningblock="warningblock"
          />

          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane class="activelabel" label="合同附件" name="first"
                >
               <Usermanage
                  :auditState="data.auditState == 0 && permission.contract_add"
                  :projectid="data.projectId"
                  :data="data"
                />
              </el-tab-pane>
              <el-tab-pane
                class="activelabel"
                v-if="data.auditState > 1"
                label="投放列表"
                name="second"
              >
                <div class="informationxm">
                  <div class="form_wrapper">
                    <div class="form_header">
                      <div class="form_header_name">投放列表</div>
                      <div class="form_header_remarks"></div>
                    </div>
                    <avue-crud :option="option" :data="dataLaunchlist">
                      <template slot="id" slot-scope="scope">
                        <a
                          class="checkcontract"
                          @click="checkproject(scope.row.id)"
                        >
                          查看投放记录
                        </a>
                      </template>
                    </avue-crud>
                    <div></div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div>
        <el-dialog
      :close-on-click-modal="false"
          title="审核记录"
          :visible.sync="dialogVisible"
          :modal-append-to-body="false"
          width="30%"
          :before-close="handleClose"
        >
          <div class="box_cards">
            <div
              class="box_card"
              v-for="(item, index) in data.auditLog"
              :key="index"
            >
              <el-row class="demo-avatar">
                <el-col :span="5" class="demo-basic">
                  <el-avatar :size="50" :src="circleUrl"></el-avatar>
                </el-col>
                <el-col :span="12">
                  <div class="autilog">
                    <div>
                      {{ item.name }}
                      <span class="warningtext">{{ item.deptName }}</span>
                    </div>
                    <div>
                      审核{{ item.pass == true ? "通过" : "回退" }}
                      {{ item.advice }}
                    </div>
                    <div class="warningtext">
                      <i class="el-icon-time"></i>{{ item.createtime }}
                    </div>
                  </div>
                </el-col></el-row
              >
            </div>
          </div>
        </el-dialog>
        <Dialog :data="data" ref="dialogpass" />
        <History ref="history" />
        <Dialogreason
          :passdata="passdata"
          @passcheck="passcheck"
          ref="reasondialog"
        />
      </div>
      <div class="history" v-if="data.orgId != -1 || data.newId != -1">
        <div class="history_content" @click="history">
          <div class="imagehistory">
            <el-image src="/img/bg/u3205.svg"></el-image>
          </div>

          <div class="text_history">历史合同</div>
        </div>
      </div>
      <!-- <div class="history">
        <div class="history_content" @click="history"  v-if="data.orgId != -1||data.newId!=-1">
          <el-image
            class="imagehistory"
            style="width:30px; height: 30px"
            src="/img/bg/u3205.svg"
          ></el-image
          >历史合同
        </div>
      </div> -->
    </div>
  </basic-container>
</template>

<script>
import Usermanage from "./components/usermanage.vue";
import * as api from "@/api/zd/contract";
import Dialog from "./components/dialog";
import History from "./components/history";
import Dialogreason from "./components/reason";
import Details from "@/components/detail/detail";
import Detaillist from "@/components/detail/detaillist";
import { mapGetters } from "vuex";
export default {
  name: "bankmanageDetail",
  data() {
    return {
      audit_state: [],
      wfStatus: [],
      activeName: "first",
      data: {},
      passblock: false,
      passdata: {
        id: "",
        advise: "",
        pass: false,
      },
      auditstateName: "",
      butshengheloading: false,
      but_shenghe: false,
      statetitle: "",
      butstatetitle: "",
      bankStateName: "",
      examine: true,
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      dialogVisible: false,
      dataLaunchlist: [],
      option: {
        // searchIndex:3,
        searchIcon: true,
        addBtn: false,
        delBtn: false,
        columnBtn: false,
        refreshBtn: false,
        editBtn: false,
        menu: false,
        align: "center",
        column: [
          {
            label: "投放名称",
            prop: "placementTitle",
            width: "350",
          },
          {
            label: "合同金额",
            prop: "amtPlacement",
            formatter: (row, value, label, column) => {
              return this.getMoney(value) + "元";
            },
          },
          {
            label: "项目投放",
            prop: "id",
            slot: true,
          },
          {
            label: "回款状态",
            prop: "text4",
          },
        ],
      },
      detaildeta: {
        edit: "permission.contract_edit",
        add: "permission.contract_add",
        audit: "permission.contract_audit",
        title: "data.contractName",
         biangeng:'that.data.auditState>=2&&that.data.newId==-1'
      },

      detaillist: {
        column: [
          {
            label: "合同编号",
            prop: "number",
            formatter: () => {
              return this.data.contractNo == ""
                ? this.data.number
                : this.data.contractNo;
            },
          },
          {
            label: "所属项目",
            prop: "contractName ",
          },
          {
            label: "客户经理",
            prop: "managerName ",
          },
          {
            label: "合同金额",
            prop: "quota",
            formatter: () => {
              return this.getMoney(this.data.quota)+'元';
            },
          },
          {
            label: "客户名称",
            prop: "custName ",
          },
          {
            label: "申请银行",
            prop: "bankName ",
          },
          {
            label: "使用费率",
            prop: "custName ",
            formatter: () => {
              return this.data.loanRate * 100 + "%";
            },
          },
          {
            label: "使用天数",
            prop: "expectUseDay ",
               formatter: () => {
              return this.data.expectUseDay + "天";
            },
          },
          {
            label: "预出款时间",
            prop: "expectPayDate ",
          },
        ],
        showcolumn: [
          {
            label: "合同申请",
            prop: "wfStatus",
            state: 0,
            show: "pageData.wfStatus<2&&pageData.auditState == 0",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=wf_status",
          },
          {
            label: "归档审核",
            prop: "auditState",
            show: "pageData.wfStatus>=2&&pageData.auditState<1",
            auditlog: true,
            state: 0,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
          },
        ],
        firstsblock: {
          formatter: () => {
            return this.data.auditState >= "1" ? 23 : 21;
          },
        },
        sentersblock: {
          formatter: () => {
            return this.data.auditState >= "1" ? 1 : 3;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "40%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
      },
    };
  },
  components: {
    Usermanage,
    History,
    Dialogreason,
    Dialog,
    Details,
    Detaillist,
  },
  created() {
    this.onLoad(this.$route.query.id);
    this.getprojectPlacementDetail();
  },
  watch: {
    $route: {
      handler() {
        let id = this.$route.query.id;
        this.onLoad(id);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["permission"]),
    firstsblock() {
      return this.data.auditState !== 2 && this.data.wfStatus == 2 ? 6 : 7;
    },
    sentersblock() {
      return this.data.auditState !== 2 && this.data.wfStatus == 2 ? 11 : 10;
    },
    lastsblock() {
      return this.data.auditState !== 2 && this.data.wfStatus == 2 ? 7 : 7;
    },
    leftsblock() {
      return this.data.auditState !== 2 && this.data.wfStatus == 2 ? 24 : 20;
    },
    rightsblock() {
      return this.data.auditState !== 2 && this.data.wfStatus == 2 ? 1 : 4;
    },
  },
  methods: {
    getprojectPlacementDetail() {
      api.projectPlacementDetail({ id: this.$route.query.id }).then((res) => {
        
        this.dataLaunchlist = res.data.data;
      });
    },
    onLoad(id) {
      
      api
        .contractinfo({ id: id })
        .then((res) => {
          this.data = res.data.data;
          // this.data.wfStatus = res.data.data.wfStatus.toString();
          this.data.auditLog = JSON.parse(res.data.data.auditLog);
          this.data.contractTerms = res.data.data.contractTerms.slice(0, 11);
        })
        .catch((res) => {
          
        });
    },
    warningblock() {
      this.$refs.dialogpass.showblock();
    },
    history() {
      this.$refs.history.showhide(this.data.number);
    },
    // bankhistory(id) {
    //   this.$route.query.id = id;
    //   this.onLoad(this.$route.query.id);
    //   // this.onLoad(id);
    // },
    edit(id) {
      this.$router.push({ path: `/zd/contractmanage/edit/${id}` });
    },
    // 通过
    quanxian(id, type) {
      // this.passblock = true;
      // this.passtype=type
      this.passdata.id = id;
      this.$refs.reasondialog.showblock(type);
    },

    //确定通过或退回
    passcheck(data, type) {
      if (type == "change") {
        // 变更
        api.contractchange({ id: data.id, reason: data.advise }).then((res) => {
          this.$router.push({
            path: `/zd/contractmanage/edit/${res.data.data}`,
          });
        });
      } else {
        api.auditpass(data).then((res) => {
          this.onLoad(this.$route.query.id);
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        });
      }
    },
    //变更
    changes(id) {
      this.passdata.id = id;
      this.$refs.reasondialog.showblock("change");
    },
    checkproject(id) {
      // 
      this.$router.push({ path: `/zd/placement/detail/${id}` });
    },
    updatastate(type) {
      //  ture  审批  false 审核
      let that=this
      api
        .submitWorkflowCheck({ id: this.data.id })
        .then((res) => {
          
          if (type) {
            this.$confirm("是否确定提交审批?", "操作确认", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                api
                  .submitWorkflow({ id: this.data.id })
                  .then((res) => {
                    this.$alert(
                      "数据已同步至OA系统，请您前往OA工作流中查看",
                      "信息提示",
                      {
                        confirmButtonText: "确定",
                        callback: (action) => {
                          this.$message({
                            type: "info",
                            message: "请您前往OA工作流中查看",
                          });
                        },
                      }
                    );
                    this.onLoad(this.$route.query.id);
                  })
                  .catch((res) => {
                    
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
          } else {
            this.$prompt(
              '<span style="color:#f56c6c;padding-right:10px">*</span><span style="font-size:15px">合同编号</span><span class="redcolor" style="color:#f56c6c;font-size:13px;padding-left:10px">请更新确认合同编号，点击确定自动提交归档</span>',
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true,
                inputValue:
                  this.data.contractNo == ""
                    ? this.data.number
                    : this.data.contractNo,
              }
            )
              .then(({ value }) => {
                this.butshengheloading = true;
                api
                  .submitaudit({ id: this.data.id, contractNo: value })
                  .then((res) => {
                    
                    this.$message({
                      type: "success",
                      message: res.data.msg,
                    });
                    this.onLoad(this.$route.query.id);
                  })
                  .catch((res) => {
                    
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
          }
        })
        .catch((res) => {
          const confirmText = ["必填内容填写不完全", "请检查数据内容是否完整"];
          const newDatas = [];
          const h = that.$createElement;
          for (const i in confirmText) {
            newDatas.push(h("p", null, confirmText[i]));
          }
          that
            .$confirm("警告提示", {
              title: "提示",
              message: h("div", null, newDatas),
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {})
            .catch(() => {
              that.$message({
                type: "info",
                message: "已取消",
              });
            });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bankmanageDetail {
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .history {
    position: absolute;
    top: 50%;
    right: 15px;
    display: flex;
    justify-content: center;
    z-index: 20;
    flex-direction: row;
    .history_content {
      width: 100px;
      font-size: 13px;
      cursor: pointer;
      height: 45px;
      display: flex;
      flex-direction: row;
      // justify-content: center;
      background: #409eff;
      line-height: 45px;
      color: #fff;
      // text-align: right;
      // padding-right: 15px;
      border-radius: 10px 0 0 10px;
      .imagehistory {
        text-indent: 5px;
        width: 35px;
        display: flex;
        justify-content: center;
        margin-right: 8px;
        flex: 1;
      }
      .text_history {
        flex: 2;
      }
    }
  }
  .banktail_ {
    width: 1000px;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      font-weight: bolder;
    }
    .changeblock {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .historyclass {
        background: #19be6b;
        padding: 5px 10px;
        font-size: 10px;
        border-radius: 0 10px 10px 0;
        margin-right: 10px;
        color: #fff;
      }
      .reds {
        background: #f56c6c;
      }
      .orange {
        background: #fec03d;
      }
    }
  }
  .bankcontent {
    position: relative;
    margin: 20px 0;
    .el-col {
      margin-bottom: 0px;
    }
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 13px;
      // margin-bottom: 15px;
      .el-form-item {
        margin-bottom: 0px;
      }

      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        .list_top {
          flex: 1;
        }
        .towlist_top {
          text-align: right;
        }
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
        }

        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}

.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
.bankstate_0:before {
  background: #fec03d;
}
.bankstate_1:before {
  background: #51d351;
}
.bankstate_2:before {
  background: #ff7a8c;
}

.auditState_0:before {
  background: #fec03d;
}
.auditState_1:before {
  background: #409eff;
}
.auditState_2:before {
  background: #51d351;
}
.auditState_3:before {
  background: #51d351;
}
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 12px;
}
.bankmanageDetail .el-tabs__item.is-active {
  background: none;
}
.box_cards {
  height: 450px;
  overflow-y: auto;
}
.form_wrapper {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    border: 1px solid rgba(233, 233, 233, 1);
    background-color: rgba(249, 249, 249, 1);

    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.checkcontract {
  cursor: pointer;
  color: #409eff;
}
.topone {
  text-align: right;
}

/deep/.redcolor {
  color: #f56c6c;
}
/deep/.el-form-item__label {
  color: #999999;
}
/deep/.el-tabs__header {
  margin: 0px;
}
.informationxm {
  margin-top: 20px;
}
/deep/.avue-crud__menu {
  display: none;
}
/deep/.avue-crud {
  width: 100%;
}
/deep/.avue-crud .el-table th {
  background-color: #ffffff;
  line-height: 50px;
  padding: 0;
}
/deep/.el-table .cell,
.el-table th > .cell {
  padding-left: 20px;
}
/deep/.el-table__empty-block {
  border-right: none;
}
</style>
